import React from 'react';
import { CheckIcon } from 'lucide-react';
interface CheckControlProps {
  checked: boolean;
  label: string;
  onToggle: () => void;
}
export function CheckControl({
  checked,
  label,
  onToggle
}: CheckControlProps) {
  return <button type="button" role="checkbox" aria-checked={checked} aria-label={label} onClick={onToggle} className="flex h-12 w-12 shrink-0 items-center justify-center focus:outline-none focus-visible:ring-1 focus-visible:ring-fg" data-id="element-34" data-mp="14qvio0l1671f">
      <span className={`flex h-7 w-7 items-center justify-center border transition-[background-color,border-color] duration-150 ease-out ${checked ? 'border-fg bg-fg' : 'border-lineHi bg-transparent'}`} data-id="element-35" data-mp="gzge015s7dn0">
        <CheckIcon className={`h-4 w-4 text-ink transition-opacity duration-150 ease-out ${checked ? 'opacity-100' : 'opacity-0'}`} strokeWidth={3} data-id="element-36" data-mp="qzqp9g89aazj" />
      </span>
    </button>;
}